export default "__VITE_ASSET__C$KCwZQO__"